<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10I3Rih/tc-custom/9781631941641.jpg?1701400372038" alt="This image is the cover for the book Bohemian Girl, Denton"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bohemian Girl, Denton
      </h1>
      <p class="bookDescription body article font2">
        <b>A puzzling note from a troubled woman draws an American expat author into the lawless precincts of Victorian London in this historical mystery.</b><br/><br/><i>London, 1901</i>. Denton, the notorious American writer, has returned to his adoptive home after several months in one of the less-delightful corners of the Continent. He’s greeted by the usual letters from fans craving more tales of adventure—and one peculiar note: “I believe that someone threatens to harm me, and I do not know quite what to do.” Though it is signed “Mary Thomason,” it was sent by someone else. And it is more than two months old.<br/><br/> Much as he’d like to deny it, Denton is a Victorian gentlemen to the marrow. And he cannot deny a damsel in distress. His search for the mysterious Miss Thomason will take him deep into London’s “bohemian” quarters—as well as the darker corners of his own soul.<br/><br/> “Other authors have set mysteries in the same period and place, but Cameron stands out by virtue of his fine plotting and distinctive characters.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kenneth Cameron
      </h2>
      
      <p class="authorDescription body article">Kenneth Cameron, AKA George Bartram, was born June 26, 1931 in Rochester, NY. He is the author of three novels featuring Denton, an American with a violent past: <I>THE FRIGHTENED MAN, THE BOHEMIAN GIRL </I>and <I>THE SECOND WOMAN.</I> Cameron is also the author or co-author of more than thirty books, including historical fiction and espionage, a critical history of the African safari, and an award-winning analysis of films about Africa.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      FELONY & MAYHEM PRESS
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?63ec71ac